import { useCallback, useMemo, useState } from 'react';
import { SocialShareAccount } from './types';
import useSocialShareConnectedModal from './useSocialShareConnectedModal';

export interface UseSocialShareSelectedAccountResult {
  accounts: SocialShareAccount[];
  selectedAccountId: string | undefined;
  selectedAccount: SocialShareAccount | undefined;
  onSelectAccount: (accountId: string) => void;
  setAccounts: (accounts: SocialShareAccount[]) => void;
}

export default function useSocialShareSelectedAccount(): UseSocialShareSelectedAccountResult {
  const [accounts, setAccounts] = useState<SocialShareAccount[]>([]);
  const [selectedAccountId, setSelectedAccountId] = useState<
    string | undefined
  >(undefined);
  const [prevShow, setPrevShow] = useState(false);

  const { show } = useSocialShareConnectedModal();

  if (prevShow !== show) {
    setPrevShow(show);

    if (!show) {
      setSelectedAccountId(undefined);
      setAccounts([]);
    }
  }

  // Initialize to first account when modal is open and accounts are available.
  if (show && !selectedAccountId && accounts?.[0]?.id) {
    setSelectedAccountId(accounts[0].id);
  }

  const selectedAccount = useMemo(
    () => accounts?.find(({ id }) => id === selectedAccountId),
    [accounts, selectedAccountId],
  );

  const handleSetAccounts = useCallback(
    (newAccounts: SocialShareAccount[]) => {
      setSelectedAccountId(newAccounts?.[0]?.id);
      setAccounts(newAccounts);
    },
    [setAccounts],
  );

  if (!show && selectedAccountId) {
    setSelectedAccountId(undefined);
  }

  return {
    accounts,
    selectedAccountId,
    selectedAccount,
    onSelectAccount: setSelectedAccountId,
    setAccounts: handleSetAccounts,
  };
}
